import MathJax from 'MathJax';

export const mathjax = dom => MathJax.Hub.Queue(["Typeset",MathJax.Hub,dom]);
